import { useEffect, useState } from "react";
import WorkspaceCard from "./WorkspaceCard";
import { WorkspaceCardData } from "./Interfaces/WorkspaceCard";

// interface WorkspaceListProps {
//   userId?: number; // Make it optional if user?.id might be undefined
// }

export default function WorkspaceList({
  workspaces,
}: {
  workspaces: WorkspaceCardData[];
}) {
  // const [workspaces, setWorkspaces] = useState<WorkspaceCardData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (workspaces.length === 0) {
      setError("No workspaces found");
    } else {
      setError(null);
    }
    setLoading(false);
  }, [workspaces]);

  if (loading) {
    return <div className="p-8 text-center">Loading workspaces...</div>;
  }

  if (error) {
    return <div className="p-8 text-center text-red-500">{error}</div>;
  }

  return (
    <div>
      <div className="py-8">
        {workspaces.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {workspaces.map((workspace) => (
              <WorkspaceCard key={workspace.workspaceId} {...workspace} />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p>No workspaces found</p>
          </div>
        )}
      </div>
    </div>
  );
}
